import React from 'react';
import { Link } from 'react-router-dom';

const HamiltonBusinessSchool = () => {
  return (
    <div className="container mx-auto p-6">
      <div className="bg-white shadow-md rounded-lg p-6 mb-6">
        <h2 className="text-3xl font-bold mb-4">Ram College of Business &amp; Leadership</h2>
        <ul className="list-disc list-inside mb-4">
          <li>
            <Link to="/academics/mba_health_management" className="text-blue-500 underline">
              Executive Masters of Business Administration in Global Health Care Management
            </Link>
          </li>
          {/* Add more list items here if needed */}
        </ul>
      </div>
    </div>
  );
};

export default HamiltonBusinessSchool;